import { BaseRequest } from '@/network/requests/BaseRequest';
import { process_group } from '@/interfaces/process_group';

export const processGroupRequest = BaseRequest.build<process_group>('process_group');